import { render, staticRenderFns } from "./NonEligiblePanel.vue?vue&type=template&id=b460b2bc&scoped=true&"
import script from "./NonEligiblePanel.vue?vue&type=script&lang=js&"
export * from "./NonEligiblePanel.vue?vue&type=script&lang=js&"
import style0 from "./NonEligiblePanel.vue?vue&type=style&index=0&id=b460b2bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b460b2bc",
  null
  
)

export default component.exports